import { createSelector } from "reselect";
import { RootState } from "../../rootReducer";

export const selectShowToastStatus = createSelector(
  [(store: RootState) => store.profileDetail.showToastStatus],
  (usersList) => usersList
);
